/**
 * Session-expiry singleton — the tiny state machine behind the central
 * 401 handler. Lives outside AuthContext.js so unit tests can import
 * it without pulling axios (which ships as native ESM and blows up
 * inside CRA's Jest CJS runtime).
 *
 * Contract:
 *   - Exactly one handler runs per session.
 *   - `setSessionExpiryHandler` re-arms the latch (component remount).
 *   - `resetSessionExpiryLatch` re-arms the latch (post-login/register).
 *   - `triggerSessionExpired` may be called any number of times; the
 *     handler still fires at most once until the next reset.
 */

let _handler = null;
let _fired = false;

export function setSessionExpiryHandler(fn) {
  _handler = fn;
  _fired = false; // fresh registration → next 401 fires.
}

export function resetSessionExpiryLatch() {
  _fired = false;
}

export function triggerSessionExpired(url, cleanup) {
  if (_fired) return;
  _fired = true;
  if (typeof cleanup === 'function') {
    try { cleanup(); } catch { /* noop */ }
  }
  if (typeof _handler === 'function') {
    try { _handler({ url }); } catch { /* noop */ }
  }
}
